import { ENCOFFEE_PROJECT_IDS } from '@constants/projects';
import useProjectId from '@hooks/useProjectId';

import { DAILY_MAX_MAN, ENCOFFEE_DAILY_MAX_MAN } from '../constants';

/** 프로젝트별 일일 충전/구매 한도 (만원 단위) */
function useDailyMaxMan() {
    return ENCOFFEE_PROJECT_IDS.includes(useProjectId()) ? ENCOFFEE_DAILY_MAX_MAN : DAILY_MAX_MAN;
}

export default useDailyMaxMan;
